import React from 'react';
import { Col } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import 'bootstrap/dist/css/bootstrap.min.css';
//Img
import 'rsuite/dist/rsuite.min.css';
import 'react-tagsinput/react-tagsinput.css'
import Icon_Manage from '../../image/sidebar_icon/manageBook_b.png';
import Icon_Account from '../../image/sidebar_icon/account_b.png';
import Icon_Financial from '../../image/sidebar_icon/financial_b.png';
import Icon_Report from '../../image/sidebar_icon/chart_b.png';
import Icon_Contract_Agreement from '../../image/sidebar_icon/contract_b.png';
import IconBooksApprovalGra from '../../image/sidebar_icon/BooksApproval_Gray.png'; 
import IconCategoriesGray from '../../image/sidebar_icon/List_Gray.png'; 
import IconBannerGray from '../../image/sidebar_icon/Banner_Gray.png'; 
import IconShelfManagementGray from '../../image/sidebar_icon/Shelf_Gray.png'; 
import Icon_ManageReview from '../../image/sidebar_icon/Icon_ManageReview.png'; 
import IconCustomerSupportGray from '../../image/sidebar_icon/Icon_CustomerSupportGray.png'; 
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


import { useDispatch, useSelector } from 'react-redux';
import { setCurrentManageBookPage , setCurrentBooksApprovalInProgressPage , setCurrentBooksApprovalReadyofSalePage , setManageSortOption , setManageReviewSortOption , setBooksApprovalSortOption, setBookRelatedShelfSortOption} from '../../actions/site.action.js';

// Constants moved outside component to avoid recreating on every render
const focusMenuManageBook = 0;
const focusMenuAccountSetting = 1;
const focusMenuFinancial = 2;
const focusMenuReport = 3;
const focusMenuContract = 4;
const focusMenageBooksApproval = 5;
const focusCategories = 6;
const focusBanner = 7;
const focusPagesShelf = 8;
const focusManageReview = 9;
const focusCustomerSupport = 10;
const focusMenuReportAdmin = 11;
const focusShelfEbookRelated = 12;

const menuMenageBookItems = [
  "/ManageBooks",
  "/AddBooks",
  "/EditEbooks",
  "/ViewEbooks",
];

const menuAccountSettingsItems = [
  "/AccountSettings"
];

const menuFinancialItems = [
  "/Financial",
  "/ViewFinancial"
];

const menuReportItems = [
  "/Report"
];

const menuContractItems = [
  "/Contract"
];

const menuMenageBooksApproval = [
  "/BooksApproval",
  "/ViewEbooksAdmin",
  "/EditEbookAdmin"
];

const menuCategories = [
  "/Categories",
  "/AddCategories",
  "/EditCategories"
];

const menuBanner = [
  "/Banner",
  "/AddBanner",
  "/EditBanner"
];

const menuPagesShelf = [
  "/PagesShelf",
  "/ShelfManagement",
  "/ManageShelf",
  "/EditShelfManagement",
  "/ManagePageShelf"
];

const menuManageReview = [
  "/ManageReview"
];

const menuCustomerSupport = [
  "/CustomerSupport"
];

const menuReportAdmin = [
  "/ReportAdmin"
];

const menuShelfEbookRelated = [
  "/ShelfEbookRelated",
  "/ManageShelfEbookRelated"
];

function Navbar() {
  const dispatch = useDispatch();

  const userLevel = useSelector(state => state.user.userLevel) || "";
  const isImpersonatedLogin = useSelector(state => state.user.isImpersonatedLogin);

  const [selectedMenuPath, setSelectedMenuPath] = useState("/ManageBooks"); // Set initial path
  const [focusMenuIndex , setFocusMenuIndex] = useState(focusMenuManageBook);
  
  useEffect(() => {
    let currentMenuPath = window.location.pathname; // จะ pills ไปตาม URL ที่เรากด
    let shouldProcessNext = true; // Local variable instead of state

    if (menuMenageBookItems.includes(currentMenuPath)) {
      setFocusMenuIndex(focusMenuManageBook);
      setSelectedMenuPath('/ManageBooks');
      shouldProcessNext = false;
    } else {
      dispatch(setCurrentManageBookPage(1)); // เช็ค Page Ebooks เป็นหน้า 1
      dispatch(setManageSortOption([])); // set ManageBookSort ให้เป็นค่าว่าง
    }

    if (shouldProcessNext && menuAccountSettingsItems.includes(currentMenuPath)) {
      setFocusMenuIndex(focusMenuAccountSetting);
      setSelectedMenuPath("/AccountSettings");
      shouldProcessNext = false;
    }

    if (shouldProcessNext && menuFinancialItems.includes(currentMenuPath)) {
      setFocusMenuIndex(focusMenuFinancial);
      setSelectedMenuPath("/Financial");
      shouldProcessNext = false;
    }

    if (shouldProcessNext && menuReportItems.includes(currentMenuPath)) {
      setFocusMenuIndex(focusMenuReport);
      setSelectedMenuPath("/Report");
      shouldProcessNext = false;
    }

    if (shouldProcessNext && menuContractItems.includes(currentMenuPath)) {
      setFocusMenuIndex(focusMenuContract);
      setSelectedMenuPath("/Contract");
      shouldProcessNext = false;
    }

    if (shouldProcessNext && menuMenageBooksApproval.includes(currentMenuPath)) {
      setFocusMenuIndex(focusMenageBooksApproval);
      setSelectedMenuPath("/BooksApproval");
        shouldProcessNext = false;
    } else {
      dispatch(setCurrentBooksApprovalInProgressPage(1)); // เช็ค Page  เป็นหน้า 1
      dispatch(setCurrentBooksApprovalReadyofSalePage(1)); 
      dispatch(setBooksApprovalSortOption([])); 
    }

    if (shouldProcessNext && menuCategories.includes(currentMenuPath)) {
      setFocusMenuIndex(focusCategories);
      setSelectedMenuPath("/Categories");
        shouldProcessNext = false;
    }

    if (shouldProcessNext && menuBanner.includes(currentMenuPath)) {
      setFocusMenuIndex(focusBanner);
      setSelectedMenuPath("/Banner");
        shouldProcessNext = false;
    }

    if (shouldProcessNext && menuPagesShelf.includes(currentMenuPath)) {
      setFocusMenuIndex(focusPagesShelf);
      setSelectedMenuPath("/PagesShelf");
        shouldProcessNext = false;
    }

    if (shouldProcessNext && menuManageReview.includes(currentMenuPath)) {
      setFocusMenuIndex(focusManageReview);
      setSelectedMenuPath("/ManageReview");
        shouldProcessNext = false;
    } else {
      dispatch(setManageReviewSortOption([])); 
    }

    if (shouldProcessNext && menuCustomerSupport.includes(currentMenuPath)) {
      setFocusMenuIndex(focusCustomerSupport);
      setSelectedMenuPath("/CustomerSupport");
        shouldProcessNext = false;
    }

    if (shouldProcessNext && menuReportAdmin.includes(currentMenuPath)) {
      setFocusMenuIndex(focusMenuReportAdmin);
      setSelectedMenuPath("/ReportAdmin");
        shouldProcessNext = false;
    }

    if (shouldProcessNext && menuShelfEbookRelated.includes(currentMenuPath)) {
      setFocusMenuIndex(focusShelfEbookRelated);
      setSelectedMenuPath("/ShelfEbookRelated");
        shouldProcessNext = false;
    } else {
      dispatch(setBookRelatedShelfSortOption([])); 
    }

  }, [dispatch]); // Run once on mount, dispatch is stable but included for completeness

  return (

    <div className='col-siz'>
      <Col >
        <Nav variant="pills" defaultActiveKey={selectedMenuPath}>
          <div className='row-nav-link'>
            <span className='text-menu'>MENU</span>

            {userLevel === 'guest' && (
              <div>
                <Nav.Item>
                  <Link to="/ManageBooks" replace className={"menu-nav-item" + (focusMenuIndex === focusMenuManageBook ? ' active' : '')} style={{ textDecoration: 'none' , marginTop: '10px', marginBottom: '10px'}} eventkey="/ManageBooks"   >  <img src={Icon_Manage} className='icon-nav' alt='Manage Books' />Manage Books</Link>
                </Nav.Item>
                <Nav.Item>
                  <Link to="/AccountSettings" replace className={"menu-nav-item" + (focusMenuIndex === focusMenuAccountSetting ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/AccountSettings"  > <img src={Icon_Account} className='icon-nav' alt='Account Settings' />Account Settings</Link>
                </Nav.Item>

                {/* ถ้าสวบสิทธิ์Login เข้ามาจะ ซ่อน Financial */}
                {!isImpersonatedLogin && (
                <Nav.Item>
                  <Link to="/Financial" replace className={"menu-nav-item" + (focusMenuIndex === focusMenuFinancial ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/Financial"  ><img src={Icon_Financial} className='icon-nav' alt='Financial' />Financial</Link>
                </Nav.Item>
                )}
                
                <Nav.Item>
                  <Link to='/Report' replace className={"menu-nav-item" + (focusMenuIndex === focusMenuReport ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/Report"  ><img src={Icon_Report} className='icon-nav' alt='Report' />Report</Link>
                </Nav.Item>
                <Nav.Item>
                  <Link to='/Contract' replace className={"menu-nav-item" + (focusMenuIndex === focusMenuContract ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} ><img src={Icon_Contract_Agreement} className='icon-nav' alt='Contract/Agreement' />Contract/Agreement</Link>
                </Nav.Item>
              </div>
            )}

            {userLevel === 'admin' && (

              <div>
                <Nav.Item>
                  <Link to="/BooksApproval" replace className={"menu-nav-item" + (focusMenuIndex === focusMenageBooksApproval ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/BooksApproval"  > <img src={IconBooksApprovalGra} className='icon-nav' alt='Books Approval' />Books Approval</Link>
                </Nav.Item>
                <Nav.Item>
                  <Link to="/Categories" replace className={"menu-nav-item" + (focusMenuIndex === focusCategories ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/Categories"  ><img src={IconCategoriesGray} className='icon-nav' alt='Categories' />Categories</Link>
                </Nav.Item>
                <Nav.Item>
                  <Link to="/Banner" replace className={"menu-nav-item" + (focusMenuIndex === focusBanner ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/banner"  ><img src={IconBannerGray} className='icon-nav' alt='Banner' />Banner</Link>
                </Nav.Item>
                <Nav.Item>
                  <Link to="/PagesShelf" replace className={"menu-nav-item" + (focusMenuIndex === focusPagesShelf ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/ShelfManagement"  ><img src={IconShelfManagementGray} className='icon-nav' alt='Shelf Management' />Shelf Management</Link>
                </Nav.Item>

                <Nav.Item>
                  <Link to="/ManageReview" replace className={"menu-nav-item" + (focusMenuIndex === focusManageReview ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/ManageReview"  ><img src={Icon_ManageReview} className='icon-nav' alt='Manage Review' />Manage Review</Link>
                </Nav.Item>
                
                <Nav.Item>
                  <Link to="/CustomerSupport" replace className={"menu-nav-item" + (focusMenuIndex === focusCustomerSupport ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/CustomerSupport"  ><img src={IconCustomerSupportGray} className='icon-nav' alt='Customer Support' />Customer Support</Link>
                </Nav.Item>
                <Nav.Item>
                  <Link to='/ReportAdmin' replace className={"menu-nav-item" + (focusMenuIndex === focusMenuReportAdmin ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/Report"  ><img src={Icon_Report} className='icon-nav' alt='Report' />Report</Link>
                </Nav.Item>
                <Nav.Item>
                  <Link to="/ShelfEbookRelated" replace className={"menu-nav-item" + (focusMenuIndex === focusShelfEbookRelated ? ' active' : '')} style={{ textDecoration: 'none', marginTop: '10px', marginBottom: '10px'}} eventkey="/ShelfEbookRelated"  ><img src={IconShelfManagementGray} className='icon-nav' alt='Shelf Ebook Related' />Shelf Book Related</Link>
                </Nav.Item>
                
              </div>
            )}


          </div>
        </Nav>
      </Col>
    </div>
  );
};

export default Navbar;
